import { useTranslation } from 'react-i18next';
import { Affix, Button } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { ROUTER } from '../../../../constants/router';
import { STATUS_ID as STATUS } from '../../STATUS_ID';

const Tab5 = ({ remarks, editMode, isNoPermission, dataFlowInfo }) => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { businessProcessId } = useParams();

    return (
        <div className="grid grid-cols-3">
            <div className="col-span-3 text-right mt-2 mb-2">
                <Affix offsetTop={60}>
                    <Button
                        hidden={!editMode || (isNoPermission && dataFlowInfo.statusId !== STATUS.REVISE)}
                        type="primary"
                        style={{ padding: '0px 30px' }}
                        onClick={() => {
                            navigate(
                                `${ROUTER.DS_INVENTORY.DATAFLOW}/${businessProcessId}?tab=6`
                            );
                        }}
                        size="large"
                        ghost
                    >
                        {t('common.Edit')}
                    </Button>
                </Affix>
            </div>
            <div
                className="col-span-2 p-4 mb-4"
                style={{ backgroundColor: '#F4F6FC' }}
            >
                <span className="text-lg font-semibold text-purple">
                    {t('dataFlow.remarks')}
                </span>
                <p className="whitespace-pre-wrap">
                    {remarks?.remarksDetail ? remarks.remarksDetail : '-'}
                </p>
            </div>
            <div
                className="col-span-2 p-4 mb-4"
                style={{ backgroundColor: '#F4F6FC' }}
            >
                <span className="text-lg font-semibold text-purple">
                    {t('Has a DPA been created')}
                </span>
                <ul>
                    <li>
                        {remarks?.isDpa === true
                            ? t('Yes')
                            : remarks?.isDpa === false
                                ? t('No_')
                                : '-'}
                    </li>
                </ul>
            </div>
            <div
                className="col-span-2 p-4 mb-4"
                style={{ backgroundColor: '#F4F6FC' }}
            >
                <span className="text-lg font-semibold text-purple">
                    {t('Has a DPIA been created')}
                </span>
                <ul>
                    <li>
                        {remarks?.isDpia === true
                            ? t('Yes')
                            : remarks?.isDpia === false
                                ? t('No_')
                                : '-'}
                    </li>
                </ul>
            </div>
        </div>
    );
};
export default Tab5;
